import React from 'react';

import SoftwareImportContainer from '@totem/components/devices/software-import/SoftwareImportContainer';
import SoftwareImportLayout, {
  SoftwareImportExtra,
} from '@totem/components/devices/software-import/SoftwareImportLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const SoftwareImportPage = () => (
  <ContentLayout>
    <SoftwareImportContainer>
      <IBCard
        isCovered
        title="Software Inventory Import"
        extra={<SoftwareImportExtra />}
      >
        <SoftwareImportLayout />
      </IBCard>
    </SoftwareImportContainer>
  </ContentLayout>
);

export default SoftwareImportPage;
